import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Price } from './model/price.class';

@Component({
  selector: 'app-price-selection',
  templateUrl: './price-selection.component.html',
  styleUrls: ['./price-selection.component.css']
})
export class PriceSelectionComponent {
  @Input() prices: Price[] = [];
  @Output() priceSelected = new EventEmitter<Price>();
  @Output() priceDeselected = new EventEmitter<void>();

  selectedPrice: Price | null = null;

  constructor() { }

  selectPrice(price: Price) {
    if (this.selectedPrice === price) {
      this.selectedPrice = null; // Desseleciona o item se já estiver selecionado
      this.priceDeselected.emit();
    } else {
      this.selectedPrice = price;
      this.priceSelected.emit(price);
    }
  }

  isSelected(price: Price): boolean {
    return this.selectedPrice === price;
  }
}
